import { createSelector } from '@ngrx/store';
import * as fromApp from '../reducers/app.reducer';
import * as fromLoading from '../reducers/loading.reducer';

const selectLoading = (state: fromApp.AppState) => state.loading;

export const currentlyLoading = createSelector(selectLoading, (state: fromLoading.State) => state.current.length > 0);
